import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge, Button, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ResourceManager } from '../../../core/resource-manager';
import courseDefault from '../../../assets/course.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import banner from '../../../assets/home_mappa.webp'


import 'swiper/css';
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";


export default function HomeChiSiamo() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const isMobile = window.innerWidth < 768;


    useEffect(() => {
    }, []);


    return (
        <>

            <Container fluid className='my-5'>
                <Container fluid={'md'} className='py-5'>
                    <Row className='align-items-center'>
                        <Col md={6} sm={12} className={isMobile ? 'text-center' : ''}>
                            <h2 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px', fontWeight: 700  } : { color: 'var(--primary-color)', fontWeight: 700 }} className='mb-4'>Fedespedi</h2>
                            <h4 style={isMobile ? { color: 'var(--primary-color)', fontSize: '30px', fontWeight: 600  } : { color: 'var(--primary-color)', fontWeight: 600  }} className='mb-4'>La Federazione delle Imprese<br /> di Spedizioni Internazionali in Italia</h4>
                            <h6 className='mb-4' style={{color: 'var(--primary-color)'}}>Dal 1946, Fedespedi rappresenta il settore della logistica<br />
                                e delle spedizioni con oltre 60.000 addetti e una rete<br />
                                di oltre 30 Associazioni Territoriali.
                            </h6>
                            <Button className='mb-4 px-3' style={{ borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} onClick={() => { navigate('/associati') }}>Scopri la nostra rete<FontAwesomeIcon icon='arrow-right' className='ms-2'></FontAwesomeIcon></Button>
                        </Col>
                        <Col md={6} sm={12}>
                            <Image src={banner} style={{ width: '100%' }}></Image>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );

};